export default function BodyContainer({ className, children, ...props }) {
  return (
    <>
      <div className={`body-container ${className ?? ""}`} {...props}>
        {children}
      </div>
    </>
  );
}
